const summaryTitleSmallWords = new Set([
  "a", "an", "and", "as", "at", "but", "by", "for", "in", "of", "on", "or", "the", "to", "via",
]);

export const formatSummaryHeadings = (content: string): string =>
  (() => {
    const lines = content
      .split("\n")
      .map((line: string) => line.trim())
      .filter((line: string) => line.length > 0);
    const mergedLines: string[] = [];

    lines.forEach((line) => {
      if (/^\d+[.)]\s*/.test(line) || mergedLines.length === 0) {
        mergedLines.push(line);
      } else {
        mergedLines[mergedLines.length - 1] = `${mergedLines[mergedLines.length - 1]} ${line}`;
      }
    });

    return mergedLines
    .map((line: string) => {
      const match = line.match(/^(\s*(?:\d+[.)]\s*)?)([^:]+)(:\s*)(.*)$/);
      if (!match) {
        return line;
      }

      const [, prefix, heading, separator, body] = match;
      const words = heading.trim().split(/\s+/);
      const formattedHeading = words
        .map((word, index) => {
          const lowerWord = word.toLowerCase();
          const isFirstOrLast = index === 0 || index === words.length - 1;
          if (!isFirstOrLast && summaryTitleSmallWords.has(lowerWord)) {
            return lowerWord;
          }
          // Preserve actual acronyms, but normalize ordinary all-caps headings.
          if (
            /^(?:[A-Z]\.){2,}[A-Z]?\.?$/.test(word) ||
            ["AD", "AI", "GPT", "USA"].includes(word)
          ) {
            return word;
          }
          return lowerWord.charAt(0).toUpperCase() + lowerWord.slice(1);
        })
        .join(" ");

      return `${prefix}${formattedHeading}${separator}${body}`;
    })
    .join("\n");
  })();



// WEBPACK FOOTER //
// ./src/features/director/pages/summaryFormatting.ts